import { Box, Tab, Tabs } from "@mui/material"
import { CreateEvent } from "./CreateEvent"
import ViewEvents from "@/components/admin/ViewEvents"
import ViewAttractions from "@/components/admin/ViewAttractions"
import CreateAttraction from "./CreateAttraction"
import { Route, Routes, useLocation, useNavigate } from "react-router-dom"
import { ManageAdvertisements } from "./ManageAdvertisement"

export default function AdminEvents() {
  const location = useLocation()
  const navigate = useNavigate()

  // Map routes to tab indices
  const tabRoutes = [
    "/admin/view",
    "/admin/create-event",
    "/admin/view-attractions",
    "/admin/create-attraction",
    "/admin/advertisements",
  ]
  const currentTab = tabRoutes.includes(location.pathname)
    ? location.pathname
    : false

  const handleTabChange = (event: object, newValue: string) => {
    navigate(`${newValue}`) // Update the route based on tab index
  }
  return (
    <>
      <Box
        sx={{
          paddingX: "2rem",
          paddingBottom: "2rem",
          position: "relative",
        }}
      >
        <Box display="flex" flexDirection="row">
          <Tabs
            // value={tabValue}
            value={currentTab}
            // onChange={(_e, newValue: "view" | "create" | "attraction") => {
            //   setTabValue(newValue)
            // }}
            onChange={handleTabChange}
            indicatorColor="primary"
          >
            <Tab
              label="View Events"
              value="/admin/view"
              sx={{ fontSize: "24px", paddingY: 0 }}
            />
            <Tab
              label="Create Event"
              value="/admin/create-event"
              sx={{ fontSize: "24px", paddingY: 0 }}
            />
            <Tab
              label="View Attractions"
              value="/admin/view-attractions"
              sx={{ fontSize: "24px", paddingY: 0 }}
            />
            <Tab
              label="Create Attraction"
              value="/admin/create-attraction"
              sx={{ fontSize: "24px", paddingY: 0 }}
            />
            <Tab
              label="Manage Advertisements"
              value="/admin/advertisements"
              sx={{ fontSize: "24px", paddingY: 0 }}
            />
          </Tabs>
        </Box>
        <Routes>
          <Route path="/view" element={<ViewEvents />} />
          <Route path="/create-event" element={<CreateEvent />} />
          <Route path="/view-attractions" element={<ViewAttractions />} />
          <Route path="/create-attraction" element={<CreateAttraction />} />
          <Route path="/advertisements" element={<ManageAdvertisements />} />
        </Routes>
        {/* {tabValue === "view" && <ViewEvents />} */}
        {/* {tabValue === "create" && <CreateEvent />} */}
        {/* {tabValue === "attraction" && <CreateAttraction />} */}
      </Box>
    </>
  )
}
